import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login.vue'
import Register from './views/Register.vue'
import Main from './views/Main.vue'

import GlobalListPage from './components/pages/GlobalListPage.vue'
import SkillsListPage from './components/pages/SkillsListPage.vue'
import SkillPage from './components/pages/SkillPage.vue'
// import ChatBotPage from './components/pages/ChatBotPage.vue'
import IntentPage from './components/intent/IntentPage.vue'
import MooTest from './components/MooTest.vue'
import Oauth2Callback from './components/Oauth2Callback.vue'
import UsersListPage from './components/pages/UsersListPage.vue'
import UserPage from './components/pages/UserPage.vue'
import EntityPage from './components/pages/EntityPage.vue'
import SynonymPage from './components/pages/SynonymPage.vue'
import ScriptPage from './components/pages/ScriptPage.vue'
import ApiPage from './components/pages/ApiPage.vue'

import DomainsSelector from './components/DomainsSelector.vue'

Vue.use(Router)

const Test = {
  name: 'Test',
  components: {
    DomainsSelector,
  },
  data () {
    return {
      selected: {
        'da': true,
      },
      domains: [
        'da.sda',
        'da.sdb',
        'dc',
        'dc.sdc',
        'dd',
      ],
    }
  },
  template: `
    <domains-selector
      v-model="selected"
      :domains="domains"
      ></domains-selector>
  `,
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login },
    {
      path: '/register',
      name: 'register',
      component: Register },
    { path: '/moo',
      component: MooTest },
    { path: '/test',
      component: Test },
    { path: '/oauth2/callback',
      component: Oauth2Callback },
    {
      path: '',
      name: 'main',
      component: Main,
      children: [
        { path: '/global',
          name: 'global',
          component: GlobalListPage,
          props: route => ({
            view: route.query.view,
            compare: route.query.compare,
          }) },
        // { path: '/skills',
        //   name: 'skills',
        //   component: SkillsListPage,
        //   props: route => ({
        //     view: route.query.view,
        //     compare: route.query.compare,
        //   }) },
        { path: '/',
          name: 'home',
          component: SkillsListPage,
          props: route => ({
            view: route.query.view,
            compare: route.query.compare,
          }) },
        { path: '/skills/:skill',
          name: 'skill',
          component: SkillPage,
          props: route => ({
            skill: route.params.skill,
            view: route.query.view,
            compare: route.query.compare,
          }) },
        // { path: '/skills/:skill/chatbot',
        //   name: 'chatbot',
        //   component: ChatBotPage,
        //   props: route => ({
        //     skill: route.params.skill,
        //   }) },
        { path: '/skills/:skill/intents/:intent',
          name: 'intent',
          component: IntentPage,
          props: route => ({
            skill: route.params.skill,
            intent: route.params.intent,
            context: route.query.context,
            view: route.query.view,
            compare: route.query.compare,
          }) },
        { path: '/skills/:skill/entities/:entity',
          name: 'entity',
          component: EntityPage,
          props: route => ({
            skill: route.params.skill,
            entity: route.params.entity,
            view: route.query.view,
            compare: route.query.compare,
          }) },
        { path: '/skills/:skill/synonyms/:synonym',
          name: 'synonym',
          component: SynonymPage,
          props: route => ({
            skill: route.params.skill,
            synonym: route.params.synonym,
            view: route.query.view,
            compare: route.query.compare,
          }) },
        { path: '/skills/:skill/scripts/:script',
          name: 'script',
          component: ScriptPage,
          props: route => ({
            skill: route.params.skill,
            script: route.params.script,
            view: route.query.view,
            compare: route.query.compare,
          }) },
        { path: '/skills/:skill/api/:api',
          name: 'api',
          component: ApiPage,
          props: route => ({
            skill: route.params.skill,
            api: route.params.api,
            view: route.query.view,
            compare: route.query.compare,
          }) },
        { path: '/users',
          name: 'users',
          component: UsersListPage },
        { path: '/users/:user',
          name: 'user',
          component: UserPage,
          props: route => ({
            user: route.params.user,
          }) },
      ] },
  ],
})
